import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from 'primereact/inputtextarea';  
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { getDataApi1, loadApi, saveApi1, loadApi1, delApi1} from "../services/appApi";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const Tasks  = () => {

  let emptyRow = {
    task_id :null,
    client_id :null,
    user_id :null,
    tax_year :null,
    task_name :null,
    task_type_lkcd :null,
    task_priority_lkcd :null,
    task_status_lkcd :null,
    task_completion_date :null,
    task_repeat_frequency_lkcd :null,
    due_date :null,
    task_long_description :null,
    followup_date :null,
    followup_actions :null,
    lesson_learn_date :null,
    lesson_learned :null,
    task_number :null,
    task_type_mean :null,
    task_type_desc :null,
    task_priority_mean :null,
    task_priority_desc :null,
    task_status_mean :null,
    task_status_desc :null,
    task_repeat_frequency_mean :null,
    task_repeat_frequency_desc :null,
    firm_id :null,
    client_type_lkcd :null,
    client_type_mean :null,
    client_type_desc :null,
    business_legal_name :null,
    business_dba_name :null,
    business_federal_tax_id :null,
    business_phone_number :null,
    business_email_address :null,
    client_first_name :null,
    client_middle_name :null,
    client_last_name :null,
    spouse_first_name :null,
    spouse_middle_name :null,
    spouse_last_name :null,
    client_federal_tax_id :null,
    client_federal_tax_id_type :null,
    spouse_federal_tax_id :null,
    spouse_federal_tax_id_type :null,
    client_contact_cell_phone :null,
    client_contact_work_phone :null,
    client_contact_home_phone :null,
    client_contact_email_address :null,
    spouse_contact_cell_phone :null,
    spouse_contact_work_phone :null,
    spouse_contact_home_phone :null,
    spouse_contact_email_address :null,
    tax_year_description :null,
    creation_date :null,
    last_update_date :null,
    created_by :null,
    last_updated_by :null
    };

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
      tax_year: {value: null, matchMode: FilterMatchMode.IN,}
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const userId = localStorage.getItem("taxUserId");

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_tasks_v/?offset=${offset}&limit=${limit}`);
        allData = [...allData, ...response.data.items];
        console.log(allData);
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  useEffect(() => {
      const fetchClient = async () => {
        setFetchClientFlag(true);
        try {
          let offset = 0;
          let limit = 25;
          let hasMore = true;
          let allData = [];
          let status = null;
          while (hasMore) {
            const response = await getDataApi1(
              `/ztx_firm_clients_v/?offset=${offset}&limit=${limit}`,
            );
            allData = [...allData, ...response.data.items];
            status = response.status;
            hasMore = response.data.hasMore;
            offset = offset + limit;
          }
          if (allData.length > 0) {
            const options = allData.map((item) => ({
              label: item.client_first_name,
              value: item.client_id,
            }));
            setClientNameOptions(options);
            console.log(options);
            setFetchClientFlag(false);
          }
        } catch (err) {
          console.error(err);
          setFetchClientFlag(false);
        }
      };
      fetchClient();
    }, []);

  const dueDateTemplate = (rowData) => {
      return rowData.due_date ? moment.utc(rowData.due_date).format("YYYY-MM-DD") : null;
    };
  const completionDateTemplate = (rowData) => {
      return rowData.task_completion_date ? moment.utc(rowData.task_completion_date).format("YYYY-MM-DD") : null;
    };
  const lessLearnDateTemplate = (rowData) => {
      return rowData.lesson_learn_date ? moment.utc(rowData.lesson_learn_date).format("YYYY-MM-DD") : null;
    };
  const numTaskNumberTemplate = (rowData) => {
    return (rowData.task_number || rowData.task_number === 0) ? numeral(rowData.task_number).format('0,0') : null;
  };
  

  const dueDate = row.due_date ? moment.utc(row.due_date).format("YYYY-MM-DD") : null;
  const completionDate = row.task_completion_date ? moment.utc(row.task_completion_date).format("YYYY-MM-DD") : null;
  const lessLearnDate = row.lesson_learn_date ? moment.utc(row.lesson_learn_date).format("YYYY-MM-DD") : null;
  const numTaskNumber = (row.task_number || row.task_number === 0) ? numeral(row.task_number).format('0,0') : null;
  
  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };

  const showNewProduct = () => {
    setRow(emptyRow);
    setCurrentMode('I');
    setShowProductDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R')
    setShowProductDialog(true);
}

const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U')
    setShowProductDialog(true);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Tasks Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Tasks
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
       <Button
          // label="New"
          icon="pi pi-plus"
          className="p-button-success p-button-rounded p-mr-2"
          onClick={showNewProduct}
          tooltip="New"
          tooltipOptions={{ position: "bottom" }}
        />
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

   const editBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-secondary"
          onClick={() => showEditProduct(rowData)}
          tooltip="Edit"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select"
    display="chip" showClear/>
  )
  const getOraDateFormat24 = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("YYYY-MM-DDTHH:mm:ss[Z]") : null;
  };

  const descriptionBodyTemplate = (rowData) => {
    const text = rowData.task_long_description || "";
    const maxLength = 30;

    return (
        <span title={text}>
            {text.length > maxLength
                ? `${text.substring(0, maxLength)}...`
                : text}
        </span>
    );
};

 const lessonLearnedTemplate = (rowData) => {
    const text = rowData.lesson_learned || "";
    const maxLength = 30;

    return (
        <span title={text}>
            {text.length > maxLength
                ? `${text.substring(0, maxLength)}...`
                : text}
        </span>
    );
};

 const followupActionsTemplate = (rowData) => {
    const text = rowData.followup_actions || "";
    const maxLength = 30;

    return (
        <span title={text}>
            {text.length > maxLength
                ? `${text.substring(0, maxLength)}...`
                : text}
        </span>
    );
};

  const saveData = async (currentMode) => {
    if(currentMode === 'I') {
    try {
      const p_param = {
        p_user_id: userId,
        p_client_id: row.client_id,
        p_tax_year: row.tax_year, 
        p_task_number: row.task_number,
        p_task_name: row.task_name,                                                
        p_task_long_description: row.task_long_description,                                   
        p_followup_actions: row.followup_actions,                                                         
        p_lesson_learned: row.lesson_learned,         
        p_task_completion_date: row.task_completion_date
          ? moment(row.task_completion_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,
        p_followup_date: row.followup_date
          ? moment(row.followup_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,
        p_lesson_learn_date: row.lesson_learn_date
          ? moment(row.lesson_learn_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,
        p_due_date: row.due_date
          ? moment(row.due_date)
              .utc()
              .format("YYYY-MM-DDTHH:mm:ss[Z]")
          : null,
      };
      console.log("Insert p_param: ", p_param);
      const response = await loadApi1(
        p_param,
        "/ztx_client_tasks/v1/",
      );
      console.log(response);
      console.log(response.data);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Inserted",
        });
        const newRow = {
          task_id: response.data.o_task_id,
          ...row,
        };
        setRows((prev) => [...prev, newRow]);
        setShowProductDialog(false);
        setCurrentMode('');
        setRow(emptyRow);
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Inserted",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
        setErrorDialogVisible(true);
      }
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  } else if (currentMode === 'U'){

     const p_param = {                                                                              
	        p_user_id: userId,                                       
          p_client_id: row.client_id,                                                                 
          p_tax_year: row.tax_year,                                                                   
          p_task_number: row.task_number, 
          p_task_name: row.task_name,                                               
          p_task_long_description: row.task_long_description,                                   
          p_followup_actions: row.followup_actions,                                                         
          p_lesson_learned: row.lesson_learned,                                   
          p_task_id: row.task_id,                                                                           
          p_task_completion_date: getOraDateFormat24(row.task_completion_date),                 
          p_followup_date: getOraDateFormat24(row.followup_date),   
          p_lesson_learn_date: getOraDateFormat24(row.lesson_learn_date), 
          p_due_date: getOraDateFormat24(row.due_date), 
     };                                                                                             
   
    console.log("Edit p_param: ", p_param);
    try {
      const response = await saveApi1(
        p_param,
        `/ztx_client_tasks/v1/`,
      );
      console.log(response);
      if (response.data.o_success_flag === "Y") {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Data Updated",
        });
        setRows((prev) =>
          prev.map((data) =>
            data.task_id === row.task_id
              ? { ...row }
              : data,
          ),
        );
        setShowProductDialog(false);
        setCurrentMode('');
      } else {
        const err_msg = response.data.o_return_msg;
        toast.current.show({
          severity: "error",
          summary: err_msg,
          detail: "Data Not Updated",
          life: 3000,
          width: "600px",
        });
        setErrorMessage(err_msg);
      }

      //setRows(response.data);
    } catch (error) {
      if (axios.isCancel(error) || error.name == "CanceledError") {
        toast.current.show({
          severity: "warn",
          summary: "Cancelled",
          detail: "Request successfully cancelled by the user.",
          life: 3000,
        });
      } else {
        // Set the error message and display the dialog
        setErrorMessage(error.message);
        setErrorDialogVisible(true);
      }
    }
  }
  };

    const hideDeleteRowDialog = () => {
      setDeleteRowDialog(false);
    };

    const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };

    const deleteRow = async () => {
      const p_param = {
        p_user_id: userId,
        p_task_id: row.task_id,
      };
      try {
        const response = await delApi1(
          { params: p_param },
          "/ztx_client_tasks/v1/",
        );
        let successFlag = response.data.o_success_flag;
        if (successFlag === "Y") {
          let _rows = rows.filter((val) => val.task_id !== row.task_id);
          setRows(_rows);
          setDeleteRowDialog(false);
          setRow(emptyRow);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Task Deleted",
            life: 3000,
            width: "600px",
          });
        } else {
          let err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Task Not Deleted",
            life: 3000,
            width: "600px",
          });
        }
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Task Deletion Failed",
          life: 3000,
          width: "600px",
        });
      }
    };

    const deleteRowDialogFooter = (
      <React.Fragment>
        <Button
          label="No"
          icon="pi pi-times"
          severity="secondary"
          onClick={hideDeleteRowDialog}
        />
        <Button label="Yes" icon="pi pi-check" onClick={deleteRow} />
      </React.Fragment>
    );

    const actionBodyDeleteTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-warning"
            onClick={() => confirmDeleteRow(rowData)}
            tooltip="Delete"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
    };
  

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">Tasks</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_w2_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
        >

          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={actionBodyDeleteTemplate} style={{ width: "0.75rem" }} ></Column>
          <Column field="due_date" header="DueDate" body={dueDateTemplate} sortable></Column>
          <Column field="tax_year" header="TxYr" filter showFilterMenu={false} filterElement={taxYearFilterTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} filterElement={clientFilterTemplate}></Column>
          <Column field="task_priority_mean" header="Pri" sortable></Column>
          {/* <Column field="dtl_control_tax_topics" header="TT" sortable></Column> */}
          <Column field="task_name" header="Task/Info" sortable></Column>
          <Column field="task_number" header="#" body={numTaskNumberTemplate} sortable></Column>
          {/* <Column field="task_long_description" header="Description" sortable></Column> */}
          <Column field="task_long_description" header="Description" body={descriptionBodyTemplate} sortable />
          <Column field="task_status_mean" header="Status" sortable></Column>
          <Column field="task_type_mean" header="Type" sortable></Column>
          <Column field="followup_actions" header="Followup" body={followupActionsTemplate} sortable></Column>
          <Column field="task_repeat_frequency_mean" header="Repeat" sortable></Column>
          <Column field="task_completion_date" header="Completion" body={completionDateTemplate} sortable></Column>
          <Column field="lesson_learn_date" header="LessLearnDate" body={lessLearnDateTemplate} sortable></Column>
          <Column field="lesson_learned" header="LessonLearned" body={lessonLearnedTemplate} sortable></Column>
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="Tasks" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="due_date">DueDate</label>
                    <div className="box">
                        {dueDate}
                    </div>

                <label htmlFor="tax_year">TxYr</label>
                    <div className="box">
                        {row.tax_year}
                    </div>

                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="task_priority_mean">Pri</label>
                    <div className="box">
                        {row.task_priority_mean}
                    </div>

                <label htmlFor="task_name">Task/Info</label>
                    <div className="box">
                        {row.task_name}
                    </div>
                <label htmlFor="task_number">#</label>
                    <div className="box">
                        {numTaskNumber}
                    </div>

                <label htmlFor="task_long_description">Description</label>
                    <div className="box">
                        {row.task_long_description}
                    </div>

                <label htmlFor="task_status_mean">Status</label>
                    <div className="box">
                        {row.task_status_mean}
                    </div>

                <label htmlFor="task_type_mean">Type</label>
                    <div className="box">
                        {row.task_type_mean}
                    </div>
                <label htmlFor="followup_actions">Followup</label>
                    <div className="box">
                        {row.followup_actions}
                    </div>

                <label htmlFor="task_repeat_frequency_mean">Repeat</label>
                    <div className="box">
                        {row.task_repeat_frequency_mean}
                    </div>

                <label htmlFor="task_completion_date">Completion</label>
                    <div className="box">
                        {completionDate}
                    </div>
                <label htmlFor="lesson_learn_date">LessLearnDate</label>
                    <div className="box">
                        {lessLearnDate}
                    </div>
                <label htmlFor="lesson_learned">LessonLearned</label>
                    <div className="box">
                        {row.lesson_learned}
                    </div>

            </Dialog> */}

            <Dialog
                      // header="Add Task"
                      header={currentMode === 'I' ? "Add Task" : currentMode === 'U' ? "Update Task" : currentMode === 'R' ? "View Task" : "Task"}
                      visible={showproductDialog}
                      style={{ width: "40rem" }}
                      onHide={() => setShowProductDialog(false)}
                    >
                      <div className="p-fluid">
                        <div className="field">
                          <label>Client</label>
                          <Dropdown
                            value={row.client_id}
                            disabled = {currentMode === 'R' ? true : false}
                            options={clientNameOptions}
                            optionLabel="label"
                            optionValue="value"
                            placeholder="Select Client"
                            onChange={(e) => {
                              const selectedOption = clientNameOptions.find(
                                (option) => option.value === e.value,
                              );
                              setRow({
                                ...row,
                                client_id: e.value,
                                client_first_name: selectedOption?.label || "",
                              });
                            }}
                          />
                        </div>
                        
                        <div className="field">
                          <label>Tax Year</label>
                          <InputNumber
                            value={row.tax_year}
                            disabled = {currentMode === 'R' ? true : false}
                            useGrouping={false}
                            onChange={(e) => setRow({ ...row, tax_year: e.value })}
                          />
                        </div>
                        <div className="field">
                          <label>Due Date</label>
                          <Calendar
                            value={row.due_date ? new Date(row.due_date) : null}
                            disabled = {currentMode === 'R' ? true : false}
                            dateFormat="yy-mm-dd"
                            showIcon
                            onChange={(e) =>
                              setRow({ ...row, due_date: e.value })
                            }
                          />
                        </div>
                        <div className="field">
                            <label>Task</label>
                            <InputText
                              value={row.task_name}
                              disabled = {currentMode === 'R' ? true : false}
                              onChange={(e) =>
                                setRow({ ...row, task_name: e.target.value })
                              }
                            />
                        </div>
                        {currentMode === 'R' ? (
                           <div className="field">
                                <label>Pri</label>
                                <InputText
                                  value={row.task_priority_mean}
                                  disabled = {currentMode === 'R' ? true : false}
                                />
                            </div>
                        ) : null}

                        {currentMode === 'R' ? (
                           <div className="field">
                                <label>Status</label>
                                <InputText
                                  value={row.task_status_mean}
                                  disabled = {currentMode === 'R' ? true : false}
                                />
                            </div>
                        ) : null}

                        {currentMode === 'R' ? (
                           <div className="field">
                                <label>Type</label>
                                <InputText
                                  value={row.task_type_mean}
                                  disabled = {currentMode === 'R' ? true : false}
                                />
                            </div>
                        ) : null}

                        {currentMode === 'R' ? (
                           <div className="field">
                                <label>Repeat</label>
                                <InputText
                                  value={row.task_repeat_frequency_mean}
                                  disabled = {currentMode === 'R' ? true : false}
                                />
                            </div>
                        ) : null}
                        
                        <div className="field">
                          <label>#</label>
                          <InputNumber
                            value={row.task_number}
                            disabled = {currentMode === 'R' ? true : false}
                            useGrouping={true}
                            onChange={(e) => setRow({ ...row, task_number: e.value })}
                          />
                          </div>
                        <div className="field">
                          <label>Description</label>
                          <InputTextarea value={row.task_long_description} disabled = {currentMode === 'R' ? true : false} 
                            onChange={(e) => setRow({ ...row, task_long_description: e.target.value })} rows={5} cols={30}
                           />
                        </div>
                        <div className="field">
                          <label>Followup</label>
                          <InputTextarea value={row.followup_actions} disabled = {currentMode === 'R' ? true : false} 
                            onChange={(e) => setRow({ ...row, followup_actions: e.target.value })} rows={5} cols={30}
                           />
                        </div>
                        <div className="field">
                          <label>Completion Date</label>
                          <Calendar
                            value={row.task_completion_date}
                            disabled = {currentMode === 'R' ? true : false}
                            dateFormat="yy-mm-dd"
                            showIcon
                            onChange={(e) =>
                              setRow({ ...row, task_completion_date: e.value })
                            }
                          />
                        </div>
                        <div className="field">
                          <label>LessLearnDate</label>
                          <Calendar
                            value={row.lesson_learn_date}
                            disabled = {currentMode === 'R' ? true : false}
                            dateFormat="yy-mm-dd"
                            showIcon
                            onChange={(e) =>
                              setRow({ ...row, lesson_learn_date: e.value })
                            }
                          />
                        </div>
                        <div className="field">
                          <label>LessonLearned</label>
                          <InputTextarea value={row.lesson_learned} disabled = {currentMode === 'R' ? true : false} 
                            onChange={(e) => setRow({ ...row, lesson_learned: e.target.value })} rows={5} cols={30}
                           />
                        </div>
                        <div
                          style={{
                            marginTop: "1rem",
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "0.5rem",
                          }}
                        >
                          <Button
                            label="Cancel"
                            icon="pi pi-times"
                            severity="secondary"
                            onClick={() => {
                              setShowProductDialog(false);
                              setRow(emptyRow);
                              setCurrentMode('');
                            }}
                          />
                          <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                        </div>
                      </div>
                    </Dialog>
                          <Dialog
                            visible={deleteRowDialog}
                            style={{ width: "450px" }}
                            header="Confirm"
                            modal
                            footer={deleteRowDialogFooter}
                            onHide={hideDeleteRowDialog}
                          >
                            <div className="confirmation-content">
                              <i
                                className="pi pi-exclamation-triangle p-mr-3"
                                style={{ fontSize: "1.25rem", marginRight: "0.5rem" }}
                              />
                              {row && (
                                <span>
                                  Are you sure you want to delete <b>{row.task_name || row.task_id}</b>?
                                </span>
                              )}
                            </div>
                          </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}}
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default Tasks;